import styled from "styled-components";

export const StyledUnitMakers = styled.div`
	padding: 1rem;
`;

export const StyledUnitMakerUnitsContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 2rem;
`;

export const StyledUnitMakerMembersContainer = styled.div`
	margin-top: 1.8rem;
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	grid-auto-rows: auto;
	column-gap: 1.6rem;
	row-gap: 1.2rem;

	@media screen and (min-width: 1600px) {
		grid-template-columns: repeat(6, 1fr);
	}

	@media screen and (min-width: 2000px) {
		grid-template-columns: repeat(7, 1fr);
	}

	& h4 {
		width: 100%;
		padding-left: 3rem;

		display: block;
		grid-column: 1 / -1;

		font-size: 1.2rem;
		font-weight: 900;
		text-transform: uppercase;
	}
`;

export const StyledUnitMakerUnitsFooter = styled.div`
	margin-top: 5rem;

	display: flex;
	align-items: center;
	column-gap: 3rem;
`;
